import { batch } from 'react-redux';
import { getCurrentEnterpriseId, getCurrentProfileId } from '@mews-commander/core';
import { WebsocketRequestType } from '@mews-commander/enums';
import { WebsocketEventType } from '@mews-commander/legacy-data-structures';
import { modifyResourceStates } from '@mews-commander/legacy-entities/src/ducks/resources';
import { fetchSpaces, modifySpaceStates, spacesNeedsUpdate } from '@mews-commander/legacy-entities/src/ducks/spaces';
import { getCurrentProfileScopeId } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { ResourceStateUpdate } from '@mews-commander/resources';
import { CommanderThunkAction } from '@mews-commander/types';
import { createWebsocketSubscriptionActions } from '../actions';

export const SUBSCRIPTION_SPACES = 'SUBSCRIPTION_SPACES';

const [subscribe, unsubscribe] = createWebsocketSubscriptionActions(
    SUBSCRIPTION_SPACES,
    WebsocketRequestType.UpdateResourceUpdateSubscription
);

export const subscribeResourceUpdates =
    (): CommanderThunkAction =>
    (dispatch, getState, { appClockService }) => {
        const state = getState();
        const profileIds = [getCurrentProfileId()];
        const scopeIds = [getCurrentProfileScopeId(state)];
        dispatch(subscribe({ profileIds, scopeIds }));

        if (spacesNeedsUpdate(state, { appClockValue: appClockService.getValue() })) {
            const enterpriseId = getCurrentEnterpriseId();
            dispatch(fetchSpaces(enterpriseId));
        }
    };

export const unsubscribeResourceUpdates = (): CommanderThunkAction => (dispatch) => dispatch(unsubscribe());
export const spaceUpdatesHandler = {
    type: WebsocketEventType.ResourceUpdate,
    handle: (dispatch: $TSFixMe, getState: $TSFixMe, events: $TSFixMe) => dispatch(handleSpaceUpdate(events)),
};

const handleSpaceUpdate =
    (events: $TSFixMe): CommanderThunkAction =>
    (dispatch) => {
        batch(() => {
            const updates = events.map(
                (event: $TSFixMe): ResourceStateUpdate => ({
                    resourceId: event.entityId,
                    state: event.data.state,
                    stateReason: event.data.notes,
                })
            );

            dispatch(modifyResourceStates(updates));
            dispatch(modifySpaceStates(updates));
        });
    };
